<div class="grid-container">
    <div class="grid-x margin-top">
        <div class="cell large-12 medium-12 small-12">
            <text-loader [run]="true" [text]="message" [tickType]="'.'" [interval]="1000"></text-loader>
        </div>
    </div>
</div>

